import { createContext, useMemo,useState } from 'react';
import { createTheme,  } from '@mui/material/styles';


// color design tokens

const primary = '#BF295C';
const secondary = '#1E1E2D';

const defaultFontFamily = 'Inter,sans-serif';

export const themeSettings = () => {

  return {
    palette: {
      primary: {
        main: primary,
      },
      secondary: {
        main: secondary,
      }
    },
    typography: {
      fontFamily: defaultFontFamily,
      fontSize: 14,
      h1: {
        fontFamily: defaultFontFamily,
        fontSize: 44,
        fontWeight: '600',
      },
      h2: {
        fontFamily: defaultFontFamily,
        fontSize: 32,
        fontWeight: '700',
      },
      h3: {
        fontFamily: defaultFontFamily,
        fontSize: 26,
      },
      h4: {
        fontFamily: defaultFontFamily,
        fontSize: 20,
      },
      h5: {
        fontFamily: defaultFontFamily,
        fontSize: 16,
      },
      h6: {
        fontFamily: defaultFontFamily,
        fontSize: 14,
      },
      button: {
        textTransform: 'none' as const,
        fontWeight: '500' as const,
        fontSize: 16
      }
    },
    components: {
      MuiDataGrid: {
        styleOverrides: {
          row: {
            borderTopLeftRadius: '4px',
            borderTopRightRadius: '4px',
            "&.Mui-selected": {
              backgroundColor: "#BF295C",
              color: "white !important",
              "&:hover": {
                backgroundColor: "#BF295C"
              }
            },
            "&.Mui-selected > .MuiDataGrid-cell": {
              color: "white",
            },
            "&.Mui-selected > .MuiDataGrid-cell .tooltip-button .MuiSvgIcon-root": {
              color: "white",
              '&:hover': {
                color: 'white'
              }
            },
            "& .MuiDataGrid-cell": {
              color: '#1F1F1F'
            }
          }
        }
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
        },
        variants: [
          {
            props: { variant: 'contained' as const, size: 'large' as const },
            style: {
              maxHeight: 48,
              minHeight: 48,
              fontSize: 16,
              '&:hover': {
                backgroundColor: '#F56193',
              },
              '&:active': {
                backgroundColor: '#B40E47',
              },
              '&:disabled': {
                backgroundColor: '#D6D6DB',
                color: '#FAFAFA',
              },
            }
          },
          {
            props: { variant: 'contained' as const, size: 'medium' as const },
            style: {
              fontSize: 14,
              maxHeight: 38,
              minHeight: 38,
              '&:hover': {
                backgroundColor: '#F56193',
              },
              '&:active': {
                backgroundColor: '#B40E47',
              },
              '&:disabled': {
                backgroundColor: '#D6D6DB',
                color: '#FAFAFA',
              },
            }
          },

          // OUTLINED BUTTONS
          {
            props: { variant: 'outlined' as const, size: 'large' as const },
            style: {
              maxHeight: 48,
              minHeight: 48,
              borderColor: '#BF295C',
              '&:hover': {
                color: '#F56193',
                borderColor: '#F56193',
                backgroundColor: 'transparent',
              },
              '&:active': {
                backgroundColor: '#FFF8FA',
                color: '#BF295C',
                borderColor: '#BF295C',
              },
              '&:disabled': {
                backgroundColor: '#D6D6DB',
                color: '#FAFAFA',
              },
            }
          },
          {
            props: { variant: 'outlined' as const, size: 'medium' as const },
            style: {
              fontSize: 14,
              maxHeight: 38,
              minHeight: 38,
              borderColor: '#BF295C',
              '&:hover': {
                color: '#F56193',
                borderColor: '#F56193',
                backgroundColor: 'transparent',
              },
              '&:active': {
                backgroundColor: '#FFF8FA',
                color: '#BF295C',
                borderColor: '#BF295C',
              },
              '&:disabled': {
                backgroundColor: '#D6D6DB',
                color: '#FAFAFA',
              },
            }
          },
        ]
      },
    },
  };
};

export const theme = createTheme(themeSettings());

